import React from 'react'
import RealtyType, { STATUS, STATUS_COLORS } from '../../models/Realty'
import Card from '../Card'
import Text from '../Text'
import { Color } from '../../config/theme'
import DescriptionList from '../DescriptionList'
import { format } from 'date-fns'

interface Props {
  realty: RealtyType
}

const Realty: React.FC<Props> = ({ realty, children }) => {
  let address = realty.address ? `${realty.address.street}, ${realty.address.number} - ${realty.address.complement} - ${realty.address.neighborhood} - ${realty.address.city} - ${realty.address.state}` : '-'
  address = address.split('null, ').join('').split('null - ').join('')
  return (
    <Card>
      <Text
        tag="h2"
        color="darkBlue"
      >
      Imóvel #{realty.id.toString().padStart(8, '0')}
      </Text>

      <DescriptionList
        items={[
          {
            term: 'Situação',
            description: STATUS[realty.status],
            color: STATUS_COLORS[realty.status] as Color,
          }, {
            term: 'Data de cadastro',
            description: `${format(new Date(realty.created_at), 'dd/MM/yyyy HH:mm')}`,
          },
          {
            term: 'Tipo do imóvel',
            description: `${realty.type} ${realty.custom_type ? `- ${realty.custom_type}` : ''}`,
          },
          {
            term: 'Matrícula',
            description: realty.registration_number,
          }, {
            term: 'Endereço',
            description: address,
          },
        ]}
      />

      {children}
    </Card>
  )}

export default Realty
